// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionRulesMaybe_root__2OGms","title":"SectionRulesMaybe_title__3-vtb","rules":"SectionRulesMaybe_rules__3vH0I"};